// extracted by mini-css-extract-plugin
export var cardContent = "index-module--cardContent--4eLAI";
export var caseList = "index-module--caseList--8R7cz";
export var image = "index-module--image--3zi7r";